$(document).ready(function () {
  let prods = window.product.variants;
  console.log(prods);

  $(".reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value);
    if (num > 1) {
      input.value = num - 1;
    }
  });
  $(".add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value);
    input.value = num + 1;
  });

  $(".sp_options div").on("click", function () {
    if (!$(this).hasClass("active")) {
      $(this).addClass("active").siblings().removeClass("active");
      $(this)
        .parents(".sp_pro_item")
        .find(".sp_pro_img img")
        .eq($(this).index())
        .addClass("active")
        .siblings()
        .removeClass("active");
    }
  });

  $(".sp_buy_now").on("click", function () {
    let id = $(this).attr("data-id");
    let num = $(this).siblings().find("input").val();
    window.location.href = "/cart/" + id + ":" + num;
    // $.post('/api/checkout/order', {
    //     line_items: [{
    //         quantity: 1, // 数量
    //         variant_id: id, // 子商品id
    //         note: '', // 备注
    //     }],
    //     refer_info: { source: 'buy_now' }
    //     }, function (ret) {
    //     if (ret.state === 'success') {
    //         return (window.safeHref = '/checkout/' + ret.data.order_token + '?step=contact_information');
    //     } else {
    //         $.toast.show({
    //         content:
    //             {
    //             '30003': "Some items have been removed, please re-order",
    //             'line_items_variant_withdraw': "Some items have been sold out, please re-order",
    //             'line_items_variant_sold_out': "Some items are not in stock, please re-order"
    //             }[ret.state] || ret.errors[0] || "Some items information has been updated, please re-order"
    //         });
    //     }
    // });
  });

  var mySwiper = new Swiper(".swiper-container", {
    slideActiveClass: "my-slide-active",
    direction: "horizontal",
    loop: true,
    slidesPerView: 1,
    centeredSlides: window.screen.width <= 768 ? true : false,
    spaceBetween: 0,
    autoplay: {
      delay: 8000,
    },
  });
  var mySwiper2 = new Swiper(".swiper-container2", {
    direction: "horizontal",
    loop: false,
    slidesPerView: 1,
    centeredSlides: window.screen.width <= 768 ? true : false,
    spaceBetween: 5,
    on: {
      slideChangeTransitionEnd: function (swiper) {
        $(".tab_switch span").removeClass("active");
        $('.tab_switch span[cate-id="' + this.activeIndex + '"]').addClass(
          "active"
        );
      },
    },
  });

  $(".tab_switch span").click(function () {
    mySwiper2.slideToLoop($(this).attr("cate-id"), 1000, false);
    let index = $(this).attr("cate-id");
    $(".tab_switch span").removeClass("active");
    $(this).addClass("active");
  });

  $("body").click(function () {
    $("details.menu-drawer-container").removeAttr("open");
  });
});

$(function () {
  $(document).on("click", ".btn-quantity", function () {
    var inputDom = $(this).siblings('input[type="number"]');
    var inputVal = inputDom.val();
    if ($(this).hasClass("btn-quantity-plus")) {
      inputVal = parseInt(inputVal) + 1;
    } else {
      inputVal = parseInt(inputVal) - 1;
    }
    if (inputVal < 1) {
      inputVal = 1;
    }
    inputDom.val(inputVal).change();
  });
});

// function atc(){
//   var data = {
//             id:$('.main-select input:checked').val(),
//             quantity:$('.number input').val()
//       }

//       $.ajax({
//         type: 'POST',
//         url: "/cart/add.js",
//         data: data,
//         success: function(){
//           $('.c_toast').toggle()
//           setTimeout(function(){
//             $('.c_toast').toggle()
//           },1200)
//           $.getJSON(window.Shopify.routes.root + 'cart.js',function(result){
//             $('.tip').html(result.item_count)
//           })
//         },
//         dataType: 'json'
//       });
// }

// function emitCheckout(){
//   window.location.href = '/cart/' + $('.main-select input:checked').val() + ':' + $('.number input').val();
// }

function toBuyProduct(val) {
  $("html,body").animate({ scrollTop: $(val).offset().top - 8 }, 1000);
}
